<template>
  <ConclusionStep
    status="positive"
    title="Carteira editada!"
    @close="handleCloseAction"
  >
    <main class="main">
      <ContentDisplay list-length="1" class="info-box">
        <template #content-block-1>
          <HeadingDisplay
            class="title-info-box"
            title="Características da Carteira"
            size="small"
          />

          <ListDisplay
            class="list-item"
            title="Nome"
            :value="router.currentRoute.query.portfolioname"
            has-divider
          />
          <ListDisplay
            class="list-item"
            title="Tipo de gestão"
            value="Manual"
          />
        </template>
      </ContentDisplay>
    </main>
    <template #button-primary>
      <ButtonPrimary label="Investir" size="large" @click="handleNextClick" />
    </template>
  </ConclusionStep>
</template>
<script setup lang="ts">
import {
  HeadingDisplay,
  ContentDisplay,
  ButtonPrimary,
  ListDisplay,
  ConclusionStep
} from '@warrenbrasil/nebraska-web';
import { useRouter } from 'vue-router/composables';
import {
  trackEditedSuccessClose,
  trackEditedSuccessInvest
} from './track-events';

const router = useRouter();

function handleNextClick() {
  trackEditedSuccessInvest();
  router.push({
    name: 'wealthProductTransaction',
    params: { id: router.currentRoute.params.id }
  });
}

function handleCloseAction() {
  trackEditedSuccessClose();
  router.push({ name: 'wealth' });
}
</script>
<style lang="less" scoped>
.main {
  margin: 0 auto;
  max-width: 832px;
  padding: @size-spacing-x800 @size-spacing-x400;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: @size-spacing-x700;
  width: 50%;
  .info-box {
    width: 100%;
    .title-info-box {
      margin-bottom: @size-spacing-x500;
    }
    .list-item {
      margin-bottom: @size-spacing-x350;
    }
  }
}
.helper-view-success {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
